export default __webpack_public_path__ + "static/media/Recognition.06fb9349.png";